import { noForwardProps } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import { SectionContainerBlock as SectionContainerBlockType } from '@src/types/pageBuilder'
import * as R from 'ramda'
import { PropsWithChildren } from 'react'

type Props = PropsWithChildren & {
  layoutProps: SectionContainerBlockType['layoutProps']
}

const Container = styled(Box, noForwardProps)<{
  __spaceY?: number
  __maxWidth?: number
  __marginTop?: number
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${({ __maxWidth }) => __maxWidth ?? 1024}px;
  margin-right: auto;
  margin-left: auto;
  ${({ __marginTop }) =>
    R.isNotNil(__marginTop) && `margin-top: ${__marginTop}px;`}

  > * + * {
    margin-top: ${({ __spaceY }) => __spaceY ?? 60}px;
  }
`

const SectionContainerBlockView = ({ layoutProps, children }: Props) => {
  return (
    <Container
      __spaceY={layoutProps?.spaceY}
      __maxWidth={layoutProps?.maxWidth}
      __marginTop={layoutProps?.marginTop}
    >
      {children}
    </Container>
  )
}

export default SectionContainerBlockView
